export const STEPS = {
    ACCIDENT_FORM: 'Nuevo siniestro',
    DRIVER_FORM: 'Datos del conductor',
    THIRD_PARTIES_FORM: 'Datos de terceros (otros vehículos involucrados)',
    DOCS_FORM: 'Carga de archivos',
    REVIEW_FORM: 'Revisión',
    EXTENSION_FORM: 'Crear ampliación'
};

// Constantes de STEPS para el flujo (IDs únicos)
export const ACCIDENT_STEPS = {
    ACCIDENT_FORM: 'accidentForm',
    DRIVER_FORM: 'driverForm',
    THIRD_PARTIES_FORM: 'thirdPartiesForm',
    DOCS_FORM: 'docsForm',
    REVIEW_FORM: 'reviewForm',
    EXTENSION_FORM: 'extensionForm'
};
  
export const STATUS = {
    DRAFT: "draft",
    SENT: "sent",
    SENDING: "sending",
    PENDING_ORDER: "pendingOrder",
    PENDING_INSPECTION: "pendingInspection",
    IN_REPAIR: "inRepair",
    NEW_EXTENSION: "newExtension",
    REJECTED: "rejected",
    DISCARDED: "discarded",
    PAYED: "payed",
    WITHOUT_RESPONSIBILITY: "withoutResponsibility",
    WITHOUT_ANSWER: "withoutAnswer",
    LOADED: "loaded",
    ANALYSIS: "analysis",
    DEREGISTRATION: "deregistration",
    PENDING_PAYMENT: "pendingPayment",
    PENDING_DOCUMENTS: "pendingDocuments"
};

/** Estados que bloquean la opción "Cargar" (solo continuar o ver historial). */
export const BLOCK_NEW_ACCIDENT_LOAD_STATUS_IDS = new Set([
    STATUS.DRAFT,
    STATUS.SENT,
    STATUS.SENDING,
])

export { isVehicleRiskType } from 'util/riskTypes';
  
export const VEHICLE_ACCIDENT_TYPE = {
    CRYSTALS: "crystals",
    LOCKS: "locks",
    WHEEL: "wheel",
    CRASH: "crash",
    CRASH_WITH_INJURIES: "crashWithInjuries"
};
